import { PageRequest } from './page-request';
import { Logout } from '@/connections/auth';
export const loadLogout = async ({ request }: { request: Request }) => {
  try {
    const url = new URL(request.url);
    const params = PageRequest.fromSearchParams(url.searchParams);

    const handleLogout = async () => {
      await Logout();
      return { redirect: `/sign-in?${params.toParams()}` };
    };

    return { params, redirect: handleLogout() };
  } catch (e) {
    console.error('Error loading initial data');
    console.error(e);
    throw new Error('Unknown initial load error');
  }
};
